export default "__VITE_ASSET__DMkFOEbh__"